import React from "react";

const money = (v) =>
  Number(v || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const num = (v, digits = 2) =>
  Number(v || 0).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

const KpiCard = ({ label, value, sub, accent }) => (
  <div className="rounded border border-gray-200 bg-white p-4">
    <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
      {label}
    </div>
    <div
      className={`mt-1 text-xl font-semibold ${
        accent === "green"
          ? "text-green-600"
          : accent === "red"
            ? "text-red-600"
            : "text-gray-900"
      }`}
    >
      {value}
    </div>
    {sub ? <div className="mt-1 text-xs text-gray-500">{sub}</div> : null}
  </div>
);

const ReportKpis = ({ tab, kpis }) => {
  if (!kpis) return null;

  const pl = Number(kpis.profit_loss) || 0;
  const shared = [
    { label: "Total Stake", value: money(kpis.total_stake) },
    { label: "Total Payout", value: money(kpis.total_payout) },
    {
      label: "Profit / Loss",
      value: money(pl),
      accent: pl >= 0 ? "green" : "red",
    },
    { label: "Bets", value: String(kpis.bet_count ?? 0) },
  ];

  const biggestWinner =
    kpis.biggest_won_username || kpis.biggest_won_user_id
      ? `by ${kpis.biggest_won_username || kpis.biggest_won_user_id}`
      : null;

  const cards =
    tab === "users"
      ? [
          ...shared,
          { label: "Active Users", value: String(kpis.unique_users ?? 0) },
          {
            label: "Avg Winning / User",
            value: money(kpis.avg_winning_per_user),
          },
          {
            label: "Avg Win Amount",
            value: money(kpis.avg_win_amount),
            sub: "avg payout when a digit wins",
          },
          {
            label: "Avg Bets / User",
            value: num(kpis.avg_bets_per_user),
          },
          {
            label: "Avg Stake / User",
            value: money(kpis.avg_stake_per_user),
          },
          {
            label: "Biggest Won Amount",
            value: money(kpis.biggest_won_amount),
            accent: "green",
            sub: biggestWinner,
          },
          {
            label: "Profitable Users",
            value: String(kpis.profitable_users ?? 0),
            accent: "green",
          },
          {
            label: "Loss-making Users",
            value: String(kpis.loss_making_users ?? 0),
            accent: "red",
          },
        ]
      : tab === "matches"
        ? [
            ...shared,
            { label: "Matches", value: String(kpis.match_count ?? 0) },
            { label: "Users", value: String(kpis.unique_users ?? 0) },
          ]
        : [
            ...shared,
            { label: "Markets", value: String(kpis.market_count ?? 0) },
            { label: "Matches", value: String(kpis.match_count ?? 0) },
            { label: "Users", value: String(kpis.unique_users ?? 0) },
          ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
      {cards.map((c) => (
        <KpiCard key={c.label} {...c} />
      ))}
    </div>
  );
};

export default ReportKpis;
